import { createCpmsBoTransactionSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction.slice';

import { cpmsBoTransactionApi } from './cpms-bo-transaction.service';

export const cpmsBoTransactionSlice = createCpmsBoTransactionSlice({
  cpmsBoTransactionApi,
});
